/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Password/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'
import VisibilityAction from './VisibilityAction/index'



/** @type {import('Simple/types.js').View} */
export default function Password({
  children,
  viewPath = "/App/Auth/SignIn/Password",
  isInvalid,
  onChange,
  onSubmit
  
}) {
  let flow = fromFlow.useFlow()
let signinPasswordValueData = fromData.useDataValue({ viewPath,
context: 'signin',
path: 'password',
})
let signinPasswordIsValidData = fromData.useDataIsValid({ viewPath,
context: 'signin',
path: 'password',
validate: fromValidate.vaxiom_password,
required: true,
})
let signinPasswordChangeData = fromData.useDataChange({ viewPath,
context: 'signin',
path: 'password',
})
let signinPasswordSubmitData = fromData.useDataSubmit({ viewPath,
context: 'signin',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="signin.password"
 validate="/Data/validate.js vaxiom_password"
 required={true}
 invalid={!signinPasswordIsValidData}
 value={signinPasswordValueData}
 onChange={signinPasswordChangeData}
 onSubmit={signinPasswordSubmitData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Password"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<React.Fragment>
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 type={flow.has(fromFlow.normalizePath(viewPath, 'VisibilityAction/Show')) ? "text" : "password"}
/>
<VisibilityAction
{...childProps}
  viewPath={`${viewPath}/VisibilityAction`}
/>
</React.Fragment>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}